import styled from 'styled-components';
import { getFocusRingStyles } from '../utils/getFocusRingStyles';
const VizExMenuItemButton = styled.button.withConfig({
  displayName: "VizExMenuItemButton"
})(["display:flex;align-items:center;gap:8px;width:100%;padding:4px 20px;min-height:40px;text-align:left;background:none;border:none;cursor:pointer;font-size:14px;white-space:nowrap;transition:background-color 0.2s ease;&[aria-disabled='true']{cursor:not-allowed;opacity:0.5;}&:hover:not([aria-disabled='true']){background-color:rgba(0,0,0,0.04);}", ""], getFocusRingStyles({
  outlineOffset: '-2px'
}));
export default VizExMenuItemButton;